import ReverseChargeDeterminer from "@/module/Form/ReverseCharge/Strategy/ReverseChargeDeterminer";

export default class DisabledReverseCharge implements ReverseChargeDeterminer {
  async determinate(): Promise<boolean> {
    return false;
  }
}
